import React, { useState } from "react";
import "./IpSummary.scss";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";

const getIpDonorReportingDescription = (enumValue) => {
  const descriptions = {
    1: "Awaiting Field",
    2: "Data cleaning",
    3: "Data analysis",
    4: "Data translation",
    5: "IP Report Development",
    6: "Donor Report",
    7: "Completed",
  };
  return descriptions[enumValue] || "Unknown";
};

// Utility function to get IP Status description
const getIpStatusDescription = (enumValue) => {
  const descriptions = {
    1: "Discussion",
    2: "Document Review",
    3: "Pre-phase",
    4: "Data Collection",
    5: "Closed",
  };
  return descriptions[enumValue] || "Unknown";
};

// Utility function to convert true/false to "Yes"/"No"
const getPosponedStatus = (value) => (value ? "Yes" : "No");

// Utility function to format date by removing 'T'

function IpCards({ projectData }) {
  const [selected, setSelected] = useState(null);

  const cardsData = Array.isArray(
    projectData?.data?.ipSummaryIPPlanningCardResponse
  )
    ? projectData.data.ipSummaryIPPlanningCardResponse
    : [];

  const selectedCardKeyInfo = selected
    ? cardsData.find((card) => card.ipPlanIdentifier === selected)?.ipPlanKeyInfo
    : null;

  const checkStatus = (statusText) => {
    let className = "";
    let fill = "";
    let text = "";

    switch (Number(statusText)) {
      case 1:
        className = "discussion";
        fill = "var(--system-yellow-warning, #AA1A5F)";
        text = "Discussion";
        break;
      case 2:
        className = "documentReview";
        fill = "var(--system-yellow-warning, #FC9403)";
        text = "Document Review";
        break;
      case 3:
        className = "prePlanningPhase";
        fill = "var(--Primary-Blueberry-700, #325899)";
        text = "Pre Planning Phase";
        break;
      case 4:
        className = "dataCollection";
        fill = "#3B81FE";
        text = "Data Collection";
        break;
      case 5:
        className = "closed";
        fill = "#555555";
        text = "Closed";
        break;
      default:
        className = "noStatus";
        fill = " rgba(172, 12, 12, 0.777)";
        text = "No status";
        break;
    }

    return (
      <div className={className}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8px"
          height="8px"
          viewBox="0 0 9 9"
        >
          <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
        </svg>
        <span>{text}</span>
      </div>
    );
  };

  return (
    <div className="ipCardDiv">
      <h2 className="ipCardName">IP Planning Cards</h2>
      {/* Cards on the left, the key info for the selected one pinned on the
          right — it used to be the last item in the same wrapping row as the
          cards, so it moved with every window width. */}
      <div className="ipCardsLayout">
        <div className="ipCards">
          {cardsData.length === 0 && (
            <span className="ipCardsEmpty">No IP planning cards.</span>
          )}
          {cardsData.map((card) => (
            <div
              key={card.ipPlanIdentifier}
              className={`cardIp${
                selected === card.ipPlanIdentifier ? " cardIp--selected" : ""
              }`}
              role="button"
              tabIndex={0}
              onClick={() => setSelected(card.ipPlanIdentifier)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ")
                  setSelected(card.ipPlanIdentifier);
              }}
            >
              <h6 className="ipCardHeadingName">{card?.ipPlanIdentifier}</h6>
              <span className="ipCardTextName">
                Main Sector: <span>{card?.mainSector}</span>
              </span>
              <span className="ipCardTextName">
                IP/Donor Reporting Status:
              </span>
              {checkStatus(card?.ipDonorReportingEnum)}
            </div>
          ))}
        </div>
        <div className="ipCardList">
          <h3 className="ipCardListTitle">Key info</h3>
          {selectedCardKeyInfo ? (
            <>
              <span className="ipCardTextName">
                Status:{" "}
                <span>
                  {getIpStatusDescription(selectedCardKeyInfo.ipStatusEnum)}
                </span>
              </span>
              <span className="ipCardTextName">
                Planning Round: <span>{selectedCardKeyInfo.planningRound}</span>
              </span>
              <span className="ipCardTextName">
                Site Proposed:{" "}
                <span>{formatDate(selectedCardKeyInfo.siteProposed)}</span>
              </span>
              <span className="ipCardTextName">
                Postponed:{" "}
                <span>{getPosponedStatus(selectedCardKeyInfo?.posponed)}</span>
              </span>
              <span className="ipCardTextName">
                Data Collection Completed:{" "}
                <span>{selectedCardKeyInfo.dataCollectionCompleted}</span>
              </span>
            </>
          ) : (
            <span className="ipCardTextName">
              Select a card to see its key info
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default IpCards;
